/**
 * Regroupement du Feed : les activités SUCCESSIVES d'une même personne
 * (exercices terminés / en cours / abandonnés, envois photo, notes,
 * diagnostics, défis) forment un groupe. Seule la plus récente reste visible,
 * le reste se déplie. Les devoirs, discussions, articles, visios… ne sont
 * jamais regroupés. PUR, testé.
 */

import type { FeedItem } from '@/components/news/types';
import { actorOf } from './feed-unread';

const GROUPABLE: ReadonlySet<FeedItem['kind']> = new Set([
  'attempt',
  'attempt_started',
  'submission',
  'evaluation',
  'diagnostic',
  'challenge',
]);

export interface FeedGroup {
  /** Personne dont ce sont les activités (null : élément jamais regroupé). */
  actorId: string | null;
  /** Du plus récent au plus ancien, comme le Feed. */
  items: FeedItem[];
}

/** Personne à qui rattacher l'élément pour le regroupement, sinon null. */
export function groupActorOf(item: FeedItem): string | null {
  return GROUPABLE.has(item.kind) ? actorOf(item) : null;
}

export function groupFeedItems(items: readonly FeedItem[]): FeedGroup[] {
  const groups: FeedGroup[] = [];
  for (const item of items) {
    const actor = groupActorOf(item);
    const last = groups[groups.length - 1];
    if (actor && last && last.actorId === actor) last.items.push(item);
    else groups.push({ actorId: actor, items: [item] });
  }
  return groups;
}

/** « + 3 autres activités de Léa » (prénom seul). */
export function groupToggleLabel(hidden: number, name: string): string {
  const who = name.trim().replace(/\s+/g, ' ') || 'cette personne';
  return `${hidden} autre${hidden > 1 ? 's' : ''} activité${hidden > 1 ? 's' : ''} de ${who}`;
}
